<template>
	<div class="page-in">
		<van-nav-bar
		  :title="$t('浏览记录')"
		  fixed
		  placeholder
		  left-arrow
		  z-index="99"
		  @click-left="back"
		  :border="false"
		  v-if="isMobileFlag"
		/>
		<div class="inside-page">
			<div class="layui-container" v-if="Data">
				<div class="history-top">{{$t('商品浏览记录总计')}}：{{ totalItems }} {{$t('条')}}</div>
				<div class="history-cells">
					<div class="history-group" v-for="(items, date) in Data" :key="date">
					  <div class="history-date">{{ date }}</div>
					  <div class="history-total">{{ items.length }} {{$t('件商品')}}</div>
					  <div class="product-cells">
						<el-row :gutter="20" class="product-list">
						  <el-col :xs="12" :sm="8" :md="6" v-for="item in items" :key="item.id">
							<productItem :isItemBar="false" :item="item"></productItem>
						  </el-col>
						</el-row>
					  </div>
					</div>
				</div>
			</div>
			<empty v-else></empty>	
		</div>
	</div>
</template>
<script>
	import productItem from '@/components/productItem.vue'
	import {user_goods_history_api} from "@/api/user"
	import empty from '@/components/empty.vue'
	export default {
		components:{
			empty,
			productItem
		},
		data() {
			return {
				Data:null,
				currentPage: 1,
				listPage: 1,
				listLimit: 5,
				listTotal: 0,
			};
		},
		computed: {
		    totalItems() {
		      return Object.values(this.Data).reduce((total, items) => total + items.length, 0);
		    }
		},
		methods: {
			async getGoodsHistory() {
			  let data = {
				page: this.listPage,
				limit: this.listPage == 1 ? 10 : this.listLimit,
			  };
			  const loading = this.$loading({
			    lock: true,
			    text: '',
			    spinner: 'loader',
			    background: 'rgba(255, 255, 255, 0.3)'
			  });
			  await user_goods_history_api(data).then(res => {
				if (res && res.data.code == 1) {
				  this.Data = res.data.data.lists
				  this.listTotal = res.data.data.total
				}else if(res && res.data.code == -1){
					this.goLogin()
				}
				loading.close()
			  });
			},
			handleSizeChange(e) {
			  this.listPage = e;
			  this.getGoodsHistory();
			}
		},
		mounted() {
			this.isCheckLogin()
			this.getGoodsHistory()
		}
	};
</script>
<style scoped>
	.history-cells ::v-deep .product-delete-price{
		display:none;
	}
	@media (max-width:992px) {
		.history-top{
			margin-bottom: 10px;
			padding: 10px 0;
			font-size: 20px;
		}
	}
</style>















